import ContentLoader from "react-content-loader";
const FooterLocationList = ({ records }) => {
    const skeletonRows = Array.from({ length: records });
    return (
        skeletonRows.map((_, rowIndex) => (
            <div className="col-3" key={rowIndex}>
                <div className="footermenu firstBox">
                    <ContentLoader
                        speed={2}
                        width={400}
                        height={200}
                        viewBox="0 0 400 200"
                        backgroundColor="#e0e0d9"
                        foregroundColor="#d6d6d0"
                    >
                        <rect x="10" y="10" rx="4" ry="4" width="100" height="20" /> {/* Europe text */}
                        <rect x="10" y="50" rx="4" ry="4" width="100" height="10" /> {/* Portugal */}
                        <rect x="10" y="75" rx="4" ry="4" width="100" height="10" /> {/* Croatia */}
                        <rect x="10" y="100" rx="4" ry="4" width="100" height="10" /> {/* Iceland */}
                        <rect x="10" y="120" rx="4" ry="4" width="100" height="10" /> {/* Austria */}
                    </ContentLoader>
                </div>
            </div>
        ))
    )
}
export default FooterLocationList